module.exports = __webpack_public_path__ + "img/workshop-1.6496f407.png";